import React from 'react';
import PropTypes from 'prop-types';

const ModalFooter = ({ children }) => (
  <div className="modal-footer">
    {children}
  </div>
);

ModalFooter.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
};

export default ModalFooter;



// WEBPACK FOOTER //
// ./library/app/components/Global/Modals/ModalFooter.js